import { defineMessages } from 'react-intl'

const scope = `procurify.platform.integrations.feature-sets.slack-user-linking-section`

export default defineMessages({
  syncButtonLabel: {
    id: `${scope}.syncButtonLabel`,
    defaultMessage: 'Sync unlinked users',
  },
  learnHowLinkText: {
    id: `${scope}.learnHowLinkText`,
    defaultMessage: 'Learn how to set up Slack',
  },
})
